import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Leads from "@/pages/Leads";
import LeadDetail from "@/pages/LeadDetail";
import DailyStandup from "@/pages/DailyStandup";
import Settings from "@/pages/Settings";
import Export from "@/pages/Export";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/"            element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/leads"       element={<ProtectedRoute><Leads /></ProtectedRoute>} />
            <Route path="/leads/:id"   element={<ProtectedRoute><LeadDetail /></ProtectedRoute>} />
            <Route path="/standup"     element={<ProtectedRoute><DailyStandup /></ProtectedRoute>} />
            <Route path="/export"      element={<ProtectedRoute><Export /></ProtectedRoute>} />
            <Route path="/settings"    element={<ProtectedRoute roles={["admin", "manager"]}><Settings /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors duration={3500} />
      </AuthProvider>
    </div>
  );
}

export default App;
